import React, { useContext } from "react";
import ContextApi from "../../../context/ContextApi";
import "../../../stylesheet/forms.css";

export default function PatientForm(props) {
  const {
    setPatientName,
    setEmail,
    setGender,
    setContactDetails,
    setAddress,
    setAge,
    setBloodGroup,
    setGenoType,
    setPulse,
    setWeight,
    setHeight,
    setsystolic,
    setDiastollic,
    setTemperature,
    setSugarLevel,
    setInsuranceProvider,
    setInsuranceNumber,
    patientName,
    gender,
    email,
    contactDetails,
    address,
    age,
    bloodGroup,
    genoType,
    pulse,
    weight,
    height,
    systolic,
    diastolic,
    temperature,
    sugarLevel,
    insuranceProvider,
    insuranceNumber,

  } = useContext(ContextApi);


  return (
    <div className="h-max-[620px] font-euclid-circular-a">
      <div className="border border-gray-400 rounded-2xl w-full lg:w-[750px] mt-5 summary-steps ">
        <h1 className="text-xl font-semibold ml-5 mt-4 text-gray-600">
          Patient Details
        </h1>

        <div className="mt-8 overflow-auto">
          <form onSubmit={props.onContinue}
            id="patient_form" className="p-4 lg:p-8">
            <div className="flex flex-col">
              <label htmlFor="name" className="mb-2 ml-2">
                Patient Name{" "}
              </label>
              <input
                required
                type="text"
                defaultValue={patientName}
                className="p-3 border text-black rounded"
                onChange={(e) => setPatientName(e.target.value)}
                placeholder=" Enter Patient Name"
              />
            </div>

            <div className="flex flex-col mt-3">
              <label htmlFor="name" className="mb-2 ml-2">
                Gender{" "}
              </label>
              <select
                value={gender}
                placeholder=" Select Patient Gender"
                onChange={(e) => setGender(e.target.value)}>
                <option selected>
                  Select Gender
                </option>
                <option value={'male'}>
                  Male
                </option>
                <option value={'female'}>
                  Female
                </option>
              </select>
            </div>

            <div className="flex flex-col mt-3">
              <label htmlFor="name" className="mb-2 ml-2">
                Email Address <span className="ml-1"> </span>{" "}
              </label>
              <input
                defaultValue={email}
                type="email"
                required
                className="p-3 border text-black rounded"
                onChange={(e) => setEmail(e.target.value)}
                placeholder=" Enter Email"
              />
            </div>

            <div className="flex flex-col mt-3">
              <label htmlFor="name" className="mb-2 ml-2">
                Phone Number ( 11 Digits )<span className="ml-1"> </span>{" "}
              </label>
              <input
                type="tel"
                required
                defaultValue={contactDetails}
                pattern="[0-9]{11}"
                className="p-3 border text-black rounded"
                onChange={(e) => setContactDetails(e.target.value)}
                placeholder="Enter Phone Number"
              />
            </div>

            <div className="flex flex-col mt-3">
              <label htmlFor="name" className="mb-2 ml-2">
                Residential address{" "}
              </label>
              <input
                type="text"
                defaultValue={address}
                className="p-3 border text-black rounded"
                onChange={(e) => setAddress(e.target.value)}
                placeholder=" Enter Address"
              />
            </div>

            <div className="flex flex-col mt-3">
              <label htmlFor="name" className="mb-2 ml-2">
                Age{" "}
              </label>
              <input
                pattern="\d{0,3}"
                required
                defaultValue={age}
                type="text"
                className="p-3 border text-black rounded"
                onChange={(e) => setAge(e.target.value)}
                placeholder=" Enter age"
              />
            </div>

            <div className="flex flex-col mt-3">
              <label htmlFor="name" className="mb-2 ml-2">
                Blood Group{" "}
              </label>

              <select name="" id="blood_group" value={bloodGroup} onChange={(e) => setBloodGroup(e.target.value)}>
                <option
                  selected
                >
                  Select answer
                </option>
                <option value="A+">A+</option>
                <option value="A-">A- </option>
                <option value="B+">B+ </option>
                <option value="B-">B- </option>
                <option value="AB+">AB+ </option>
                <option value="AB-">AB- </option>
                <option value="O+">O+ </option>
                <option value="O-">O- </option>
              </select>
            </div>

            <div className="flex flex-col mt-3">
              <label htmlFor="name" className="mb-2 ml-2">
                Genotype{" "}
              </label>
              <select name="" id="" onChange={(e) => setGenoType(e.target.value)} value={genoType}>
                <option
                  selected

                >
                  Select answer
                </option>
                <option value="AA"> AA </option>
                <option value="AS"> AS </option>
                <option value="AC"> AC </option>
                <option value="SS"> SS </option>
              </select>
            </div>

            <div className="flex flex-col mt-3">
              <label htmlFor="name" className="mb-2 ml-2">
                Pulse(bpm){""}
              </label>
              <input
                required
                pattern="\d{0,3}"
                type="text"
                className="p-3 border text-black rounded"
                onChange={(e) => setPulse(e.target.value)}
                defaultValue={pulse}
                placeholder=" Enter pulse"
              />
            </div>

            <div className="flex flex-col mt-3">
              <label htmlFor="name" className="mb-2 ml-2">
                Weight <span className="ml-1">(kg)</span>
              </label>
              <input
                required
                pattern="\d{0,3}"
                type="text"
                className="p-3 border text-black rounded"
                onChange={(e) => setWeight(e.target.value)}
                defaultValue={weight}
                placeholder=" Enter kg"
              />
            </div>

            <div className="flex flex-col mt-3">
              <label htmlFor="name" className="mb-2 ml-2">
                Height <span className="ml-1">(cm)</span>{" "}
              </label>
              <input
                required
                pattern="\d{0,3}"
                type="text"
                className="p-3 border text-black rounded"
                defaultValue={height}
                onChange={(e) => setHeight(e.target.value)}
                placeholder=" Enter height"
              />
            </div>

            <div className="flex mt-3 w-full gap-3 justify-center">
              <div className="w-2/5 flex flex-col">

                <label htmlFor="name" className="mb-2 ml-2">
                  Systolic <span className="ml-1">(mmHg)</span>{" "}
                </label>
                <input
                  required
                  pattern="\d{0,3}"
                  type="text"
                  className="p-3 border text-black rounded"
                  defaultValue={systolic}
                  onChange={(e) => setsystolic(e.target.value)}
                  placeholder=" Enter value"
                />
              </div>
              <span className="text-lg m-2 mt-10 text-center w-1/5">/</span>
              <div className="w-2/5 flex flex-col">
                <label htmlFor="name" className="mb-2 ml-2">
                  Diastolic <span className="ml-1">(mmHg)</span>
                </label>
                <input
                  required
                  pattern="\d{0,3}"
                  type="text"
                  className="p-3 border text-black rounded"
                  defaultValue={diastolic}
                  onChange={(e) => setDiastollic(e.target.value)}
                  placeholder=" Enter value"
                />
              </div>
            </div>

            <div className="flex flex-col mt-3">
              <label htmlFor="name" className="mb-2 ml-2">
                Temperature (°C)
              </label>
              <input
                required
                pattern="\d{0,3}"
                type="text"
                defaultValue={temperature}
                className="p-3 border text-black rounded"
                onChange={(e) => setTemperature(e.target.value)}
                placeholder=" Enter Value"
              />
            </div>

            <div className="flex flex-col mt-3">
              <label htmlFor="name" className="mb-2 ml-2">
                Sugar level <span className="ml-1">(mg/dl) </span>
              </label>
              <input
                required
                pattern="\d{0,4}"
                type="text"
                defaultValue={sugarLevel}
                className="p-3 border text-black rounded"
                onChange={(e) => setSugarLevel(e.target.value)}
                placeholder=" Enter value"
              />
            </div>

            <div className="flex flex-col mt-3">
              <label htmlFor="name" className="mb-2 ml-2">
                Insurance provider{" "}
              </label>
              <input
                type="text"
                defaultValue={insuranceProvider}
                className="p-3 border text-black rounded"
                onChange={(e) => setInsuranceProvider(e.target.value)}
                placeholder=" Enter insurance providers's name"
              />
            </div>

            <div className="flex flex-col mt-3">
              <label htmlFor="name" className="mb-2 ml-2">
                Insurance Number{" "}
              </label>
              <input
                type="text"
                defaultValue={insuranceNumber}
                className="p-3 border text-black rounded"
                onChange={(e) => setInsuranceNumber(e.target.value)}
                placeholder=" Enter insurance number"
              />
            </div>

            <div className="mt-3">
              <button
                type="submit"
                className="bg-sky-600 text-white p-2 w-36 rounded mb-11"
              >
                Continue
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
